import gql from "graphql-tag";


export const GET_CITIES = gql`
 query {
  city {
    id
    city
    country
    shortCode
    state
    }
 }
`